<template>
  <v-container fluid>
    <BaseTable
        title="Tasks"
        :subtractHeight="subtractHeight"
        :height="height"
        :dto-model="dto_model"
        dto-save-list-model="TaskSaveListCommandDTO"
        store-name="TaskTable"
        new-item-component="TaskItem"
        new-item-pass="/Task/TaskItem"
        :lang-dictionary="function(text) {return $t(text)}"
        fixed-header
        show-selected
        item-key="uid"
        :single-select="false"
        :row-background="itemRowBackground"
    >
      <template v-slot:top.right>{{ '' }}</template>
      <template v-slot:item.task_detail="{ item }">
        <BaseTaskIcon v-model="item"></BaseTaskIcon>
      </template>
      <template v-slot:item.kwargs="{ item }">
        <v-card :max-height="60" class="overflow-y-auto my-1" :color="itemRowBackground(item)">
          {{item.kwargs}}
        </v-card>
      </template>
      <template v-slot:item.create_on="{ item }">
        {{ item.create_on | moment("DD.MM.YY HH:mm:ss.SSS") }}
      </template>
      <template v-slot:item.run_on="{ item }">
        {{ item.run_on | moment("DD.MM.YY HH:mm:ss.SSS") }}
      </template>
      <template v-slot:item.end_on="{ item }">
        {{ item.end_on | moment("DD.MM.YY HH:mm:ss.SSS") }}
      </template>
    </BaseTable>
  </v-container>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";
import BaseTaskIcon from "@/components/Base/BaseTaskIcon";

export default {
  name: 'TaskTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false},
    dto_model: {type: [String], default: 'TaskListQueryDTO'},
  },

  components: {
    BaseTable,
    BaseTaskIcon,
  },

  computed: {},

  methods: {
    itemRowBackground(item) {
      if (item.state === 'SUCCESS')
        return 'green lighten-4'
      if (item.state === 'FAILURE')
        return 'red lighten-4'
      if (item.state === 'PENDING')
        return 'yellow lighten-4'
      if (item.state === 'STARTED')
        return 'orange lighten-4'
      return null
    },
  },

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {
      informationDialog: false,
      information: null,
    }
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n>
{
  "en": {
    "search": "Search",
    "columns": {
      "task_detail": " ",
      "uid": "UID",
      "worker_uid": " Worker UID",
      "source_name": " Worker name",
      "worker_ip": " Worker IP",
      "consumer_name": "Consumer name",
      "kwargs": "Params",
      "create_on": "Create on",
      "end_on": "End on",
      "run_on": "Run on",
      "state": "State",
      "result": "Result",
      "error": "Error",
      "result_ex": "Ex"
    }
  },
  "de": {
    "search": "Suche",
    "columns": {
      "task_detail": " ",
      "uid": "UID",
      "worker_uid": " Worker UID",
      "source_name": " Worker name",
      "worker_ip": " Worker IP",
      "consumer_name": "Consumer name",
      "kwargs": "Params",
      "create_on": "Create on",
      "end_on": "End on",
      "run_on": "Run on",
      "state": "State",
      "result": "Result",
      "error": "Error",
      "result_ex": "Ex"
    }
  }
}
</i18n>
